const GA4_SCRIPT_ID = "paranoidi-ga4-script";
const COOKIE_CONSENT_KEY = "paranoidi_cookie_consent_v1";

function isProductionAnalyticsHost() {
  if (typeof window === "undefined") {
    return false;
  }

  const hostname = String(window.location.hostname || "")
    .trim()
    .toLowerCase();

  return hostname === "paranoidi.fi" || hostname === "www.paranoidi.fi";
}

function getGa4MeasurementId() {
  const fromWindow =
    typeof window !== "undefined"
      ? window.PARANOIDI_GA4_MEASUREMENT_ID
      : "";

  const fromEnv = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";

  return String(fromWindow || fromEnv || "").trim();
}

export function hasAnalyticsConsent() {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const rawConsent = window.localStorage.getItem(COOKIE_CONSENT_KEY);

    if (!rawConsent) {
      return false;
    }

    const consent = JSON.parse(rawConsent);

    return consent?.analytics === true;
  } catch {
    return false;
  }
}

export function initAnalytics() {
  if (typeof window === "undefined") {
    return;
  }

  // GA4 ladataan vain oikeassa tuotantodomainissa.
  // Localhost ja staging eivät saa lähettää kehitysliikennettä Analyticsiin.
  if (!isProductionAnalyticsHost()) {
    return;
  }

  if (!hasAnalyticsConsent()) {
    return;
  }

  const measurementId = getGa4MeasurementId();

  if (!measurementId) {
    return;
  }

  if (window.gtag) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());

  window.gtag("config", measurementId, {
    send_page_view: false,
  });

  if (!document.getElementById(GA4_SCRIPT_ID)) {
    const script = document.createElement("script");

    script.id = GA4_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      measurementId
    )}`;

    document.head.appendChild(script);
  }
}

export function trackPageView(pathname) {
  if (typeof window === "undefined") {
    return;
  }

  // Sivunäkymiä ei lähetetä localhostista tai stagingista.
  if (!isProductionAnalyticsHost()) {
    return;
  }

  if (!hasAnalyticsConsent()) {
    return;
  }

  if (!window.gtag) {
    initAnalytics();
  }

  if (!window.gtag) {
    return;
  }

  const measurementId = getGa4MeasurementId();

  if (!measurementId) {
    return;
  }

  // Lähetetään SPA-reitinvaihdos oikeana GA4 page_view -tapahtumana.
  window.gtag("event", "page_view", {
    send_to: measurementId,
    page_path: pathname || window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") {
    return;
  }

  // Omia tapahtumia ei lähetetä localhostista tai stagingista.
  if (!isProductionAnalyticsHost()) {
    return;
  }

  if (!hasAnalyticsConsent()) {
    return;
  }

  if (!window.gtag) {
    initAnalytics();
  }

  if (!window.gtag) {
    return;
  }

  window.gtag("event", eventName, {
    app_name: "Paranoidi",
    ...params,
  });
}